// extracted by mini-css-extract-plugin
export default {"writeTextBlock":"WriteText_writeTextBlock__vMYjk","writeTextInput":"WriteText_writeTextInput__GWqKj","writeText":"WriteText_writeText__O-rq9","button":"WriteText_button__Zb1Lt"};